import {z} from "zod";
import {PERIOD_KEY_TYPE} from "../common/enum";

export const businessSearchFormSchema = z.object({
	dateRange: z.object({
		from: z.string().nullable(),
		to: z.string().nullable(),
		period: PERIOD_KEY_TYPE
	}),
	department: z.string().nullable(),
	managerId: z.string().nullable()
});

export type BusinessSearchFormType = z.infer<typeof businessSearchFormSchema>;

export const businessSearchYearlySchema = z.object({
	year: z.string().optional(),
	period: z.literal("YEARLY"),
	department: z.string().optional(),
	managerId: z.string().optional()
});

export type BusinessSearchYearlyForm = z.infer<typeof businessSearchYearlySchema>;

export const businessSearchMonthlySchema = z.object({
	yearMonth: z.string().optional(),
	period: z.literal("MONTHLY"),
	department: z.string().optional(),
	managerId: z.string().optional()
});

export type BusinessSearchMonthlyForm = z.infer<typeof businessSearchMonthlySchema>;

export const businessSearchWeeklySchema = z.object({
	dateFrom: z.string().optional(),
	dateTo: z.string().optional(),
	period: z.literal("WEEKLY"),
	department: z.string().optional(),
	managerId: z.string().optional()
});

export type BusinessSearchWeeklyForm = z.infer<typeof businessSearchWeeklySchema>;

const businessSearchSchema = z.discriminatedUnion("period", [
	businessSearchYearlySchema,
	businessSearchMonthlySchema,
	businessSearchWeeklySchema
]);

export type BusinessSearchType = z.infer<typeof businessSearchSchema>;

export const businessSearchWeeklyRequestSchema = z.object({
	dateRangeValue: z.object({
		from: z.string().optional(),
		to: z.string().optional()
	}),
	period: z.literal("WEEKLY"),
	department: z.string().optional(),
	managerId: z.string().optional()
});

const businessSearchRequestSchema = z.discriminatedUnion("period", [
	businessSearchYearlySchema,
	businessSearchMonthlySchema,
	businessSearchWeeklyRequestSchema
]);

export type BusinessSearchRequestType = z.infer<typeof businessSearchRequestSchema>;
